<script lang="ts">

    import Modal from './Modal.svelte';
    import TopBar from './TopBar.svelte';
    import SocialAuth from './SocialAuth.svelte';
    import { geolocation, picturesService, user } from "../Services";
    import { getContext } from 'svelte';
    import { RoutePicture } from '../Model/RoutePicture';
    import type { Route } from '../Model/Route';
    import AuthModal from './AuthModal.svelte';

    export let route: Route;

    const addPicture: (picture: RoutePicture) => void = getContext('addPicture');

    let showAuthModal = false;
    let inputElement: HTMLInputElement;

    function onUploadPictureBtnClick() {
        if (!$user) {
            showAuthModal = true;
            return;
        }

        openImageDialog();
    }

    function openImageDialog() {
        inputElement.click();
    }

    function onAuthSuccess() {
        showAuthModal = false;
    }

    function onFileInputChange(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files[0];
        input.value = '';
        uploadPicture(file);
    }

    async function uploadPicture(file: File): Promise<void> {
        try {

            if (!$user) {
                return;
            }

            showAuthModal = false;
            
            const { lon, lat } = await geolocation.getPosition();

            const labels = [
                'rutas-saludables-pto-cruz',
                route.id
            ];

            const pictureId = await picturesService.uploadPicture(file, labels, {
                coords: `${lon},${lat}`,
                user_name: $user.name,
                user_image: $user.image,
            });

            const picture = await picturesService.findById(pictureId);

            if (!picture) {
                return;
            }

            addPicture(new RoutePicture(picture));

        } catch (error) {
            console.error(error);
        }
    }

</script>

<style lang="scss">

    input[type="file"] {
        display: none;
    }

    .upload-picture-btn {
        background-color: transparent;
        border: none;
    }

    .instructions,
    .welcome {
        text-align: center;
        margin-bottom: 1rem;
    }

    .send-picture-btn {
        display: inline-flex;
        align-items: center;
    }

    .camera {
        $size: 1.5rem;
        width: $size;
        height: $size;
        margin-right: 0.25rem;
    }

</style>

<input type="file" bind:this={inputElement} on:change={onFileInputChange}>

<button type="button" class="upload-picture-btn" on:click={onUploadPictureBtnClick}>
    {#if $user}
    <img src="/images/camera-connection.svg" alt="" />
    {:else}
    <img src="/images/camera.svg" alt="" />
    {/if}
</button>

<AuthModal open={showAuthModal} on:close={() => showAuthModal = false}>
    <p class="instructions" slot="instructions">Inicia sesión para que puedas enviar tus fotografías.</p>
    <div class="welcome" slot="welcome">
        <p>
            Bienvenid@, <strong>{$user.name}</strong>, pulsa el siguiente botón para enviar tu foto.
        </p>
        <button class="btn send-picture-btn" type="button" on:click={openImageDialog}>
            <img class="camera" src="/images/camera-connection.svg" alt="" /> Enviar foto
    </button>
    </div>
</AuthModal>